<template>
    <div v-if="!loadingPage" class="pb-1">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-primary mb-2">تنظیمات ساعت کاری</h3>
            <b-button v-if="isAdminIdentityVerified" @click="updateWorkSchedule" type="submit" variant="primary"
                :disabled="loading" class="d-flex mb-2">
                <span>ذخیره تغییرات</span>
                <b-spinner v-if="loading" class="ml-50" variant="white" small></b-spinner>
            </b-button>
        </div>
        <b-card v-if="isAdminIdentityVerified">
            <b-row>
                <b-col v-for="(item, index) in workSchedule" :key="index" md="6">
                    <validation-observer #default="{ invalid }">
                        <div class="rounded border-info p-2 mb-2">
                            <h5 class="font-weight-bolder ml-1 ml-md-0 mb-1">{{ item.title }}</h5>
                            <b-row>
                                <b-col lg="3" md="6">
                                    <b-form-group>
                                        <validation-provider rules="required">
                                            <b-form-input :id="`workScheduleStart${index}`"
                                                :value="item.temporaryTime.start" placeholder="شروع"
                                                class="text-primary-middle  cursor-pointer text-center" />
                                            <date-picker v-model="item.temporaryTime.start" type="time"
                                                format="HH:mm:ss" display-format="HH:mm" :jump-minute="5"
                                                :round-minute="true" :custom-input="`#workScheduleStart${index}`" />
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3" md="6">
                                    <b-form-group>
                                        <validation-provider rules="required">
                                            <b-form-input :id="`workScheduleEnd${index}`"
                                                :value="item.temporaryTime.end" placeholder="پایان"
                                                class="text-primary-middle cursor-pointer text-center" />
                                            <date-picker v-model="item.temporaryTime.end" type="time" format="HH:mm:ss"
                                                display-format="HH:mm" :jump-minute="5" :round-minute="true"
                                                :custom-input="`#workScheduleEnd${index}`" />
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3" md="6">
                                    <b-button @click="addWorkSchedule(item)"
                                        :disabled="invalid || loading || item.items.length > 1" variant="info"
                                        class="w-100">
                                        افزودن
                                    </b-button>
                                </b-col>
                                <b-col v-if="item.items.length" lg="3" md="6" class="mt-1 mt-md-0">
                                    <b-button @click="deleteWorkSchedule(item)" class="w-100" :disabled="loading"
                                        variant="outline-danger">
                                        حذف
                                    </b-button>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col v-for="(time, i) in item.items" :key="`time${index}-${i}`" md="6" class="mt-1">
                                    <h5 class="text-center border rounded p-75 mb-0">
                                        {{ time.start.split(":").slice(0, 2).join(":") }} تا {{
                                            time.end.split(":").slice(0,
                                                2).join(":") }}
                                    </h5>
                                </b-col>
                            </b-row>
                        </div>
                    </validation-observer>
                </b-col>
            </b-row>
        </b-card>
        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BButton, BCard, BRow, BCol, BCardText, BAvatar, BSpinner, BCardBody, BFormInput, BFormGroup, BForm } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { storeService } from '@core/services';
import { required } from '@validations';


export default {
    components: {
        BFormInput,
        BCard,
        BCardText,
        BCardBody,
        BAvatar,
        BButton,
        BSpinner,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BForm,
        BRow,
        BCol
    },
    data() {
        return {
            required,
            loading: false,
            loadingPage: true,
            isAdminIdentityVerified: false,
            storeId: null,
            workSchedule: {
                saturday: {
                    title: 'شنبه',
                    items: [],
                    temporaryTime: {
                        start: null,
                        end: null
                    },
                },
                sunday: {
                    title: 'یکشنبه',
                    items: [],
                    temporaryTime: {
                        start: null,
                        end: null
                    },
                },
                monday: {
                    title: 'دوشنبه',
                    items: [],
                    temporaryTime: {
                        start: null,
                        end: null
                    },
                },
                tuesday: {
                    title: 'سه شنبه',
                    items: [],
                    temporaryTime: {
                        start: null,
                        end: null
                    },
                },
                wednesday: {
                    title: 'چهار شنبه',
                    items: [],
                    temporaryTime: {
                        start: null,
                        end: null
                    },
                },
                thursday: {
                    title: 'پنج شنبه',
                    items: [],
                    temporaryTime: {
                        start: null,
                        end: null
                    },
                },
                friday: {
                    title: 'جمعه',
                    items: [],
                    temporaryTime: {
                        start: null,
                        end: null
                    },
                },
            },
        };
    },
    methods: {
        addWorkSchedule(item) {
            item.items.push(item.temporaryTime);
            item.temporaryTime = { start: null, end: null }
        },
        deleteWorkSchedule(item) {
            item.items = []
        },
        updateWorkSchedule() {
            this.loading = true;
            let data = {
                sunday: this.workSchedule.sunday.items,
                monday: this.workSchedule.monday.items,
                tuesday: this.workSchedule.tuesday.items,
                wednesday: this.workSchedule.wednesday.items,
                thursday: this.workSchedule.thursday.items,
                friday: this.workSchedule.friday.items,
                saturday: this.workSchedule.saturday.items,
            }
            storeService.updateWorkSchedule(this.storeId, data).then(({ data }) => {
                this.$notif({ type: 'success' });
            })
                .catch((err) => {
                    this.$notif({ type: 'error' });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getInfo() {
            storeService.getInfo(this.storeId).then(({ data }) => {
                this.workSchedule.sunday.items = data.workSchedule.sunday
                this.workSchedule.monday.items = data.workSchedule.monday
                this.workSchedule.tuesday.items = data.workSchedule.tuesday
                this.workSchedule.wednesday.items = data.workSchedule.wednesday
                this.workSchedule.thursday.items = data.workSchedule.thursday
                this.workSchedule.friday.items = data.workSchedule.friday
                this.workSchedule.saturday.items = data.workSchedule.saturday
                this.loadingPage = false;
            })
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getInfo();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId");
        this.getCompletionStatus();
    },
};
</script>

<style lang="scss">
.gap-3 {
    gap: 8px;
}

.custom-file-label {
    padding-top: 9px;

    &::after {
        padding-top: 8px;
    }
}

.image-about-us {
    border: 1px solid #7267f0ce;
    border-radius: 12px;
    object-fit: cover;
}
</style>